import { NgModule } from '@angular/core';
import { FORM_PROCESSOR_MAPPING, WORKFLOW_SERVICE_MAPPING, WORKFLOW_VARIABLE_MAPPING } from '@alf-nx-workspace/shared/utils';

import { GenerischeFreigabeService } from './generische-freigabe.service';
import { GenerischeFreigabeVariablesSearchable } from './generische-freigabe.variables';
import { GenerischeFreigabeStartformProcessor } from './form-processors/generische-freigabe.startform.processor';
import { GenerischeFreigabeDokumentFreigebenProcessor } from './form-processors/generische-freigabe.dokumen-freigeben.processor';

@NgModule({
  providers: [
    {provide: WORKFLOW_SERVICE_MAPPING, useValue: GenerischeFreigabeService, multi: true},
    {provide: WORKFLOW_VARIABLE_MAPPING, useValue: GenerischeFreigabeVariablesSearchable, multi: true},
    {provide: FORM_PROCESSOR_MAPPING, useValue: GenerischeFreigabeStartformProcessor, multi: true},
    {provide: FORM_PROCESSOR_MAPPING, useValue: GenerischeFreigabeDokumentFreigebenProcessor, multi: true},
  ],
})
export class GenerischeFreigabeModule {
}
